(function () {
  'use strict';

  const FONT_NAMES = [
    'Bauhaus 93', 'Bree Serif', 'Broadway', 'Cooper Black', 'Copperplate Gothic Bold',
    'DIN 1451', 'Ethnocentric', 'Euro Plate', 'Forte', 'Good Times', 'Gunplay', 'Masked',
    'Permanent Marker', 'Pricedown', 'Stencil', 'UK-Plate'
  ];

  function normalizeText(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[’'`´]/g, '')
      .replace(/[_\-–—/:]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function sanitizeDisplayPlate(value) {
    return String(value || '')
      .toUpperCase()
      .replace(/[^\p{L}\p{N}\- ]/gu, '')
      .replace(/^\s+/, '')
      .replace(/ {2,}/g, ' ')
      .slice(0, 16);
  }

  function previewPlateValue(value) {
    return sanitizeDisplayPlate(String(value || '').split(',')[0]).trim().slice(0, 12);
  }

  function placeholder(locale) {
    return {
      nl: 'JOUW KENTEKEN', en: 'YOUR PLATE', de: 'IHR KENNZEICHEN', fr: 'VOTRE PLAQUE',
      it: 'LA TUA TARGA', pl: 'TWOJA TABLICA', cs: 'VAŠE SPZ', da: 'DIN NUMMERPLADE'
    }[locale] || 'IHR KENNZEICHEN';
  }

  function ownFontPlaceholder(locale) {
    return {
      nl: 'UW LETTERTYPE', en: 'YOUR FONT CHOICE', de: 'IHRE WUNSCHSCHRIFTART', fr: 'VOTRE POLICE',
      it: 'IL TUO FONT', pl: 'TWOJA CZCIONKA', cs: 'VAŠE PÍSMO', da: 'DIN SKRIFTTYPE'
    }[locale] || 'IHRE WUNSCHSCHRIFTART';
  }

  function getControlDescriptor(control) {
    const labels = control.labels ? Array.from(control.labels).map((label) => label.textContent || '').join(' ') : '';
    const wrapper = control.closest('.gpo-element, .globo-form-control, [class*="gpo-"], [class*="globo"], .product-form__input, .field, .uploadkit, [class*="uploadkit"]');
    const wrapperText = wrapper ? (wrapper.textContent || '').slice(0, 900) : '';
    const nodeText = (control.parentElement?.textContent || '').slice(0, 500);
    return normalizeText([
      control.name, control.id, control.value, control.getAttribute('aria-label'), control.getAttribute('placeholder'),
      control.getAttribute('title'), control.getAttribute('data-label'), control.getAttribute('data-value'),
      labels, wrapperText, nodeText
    ].filter(Boolean).join(' '));
  }

  function findPlateInput(scope, root) {
    const productScope = scope.querySelector('product-info, .product, [id^="MainProduct-"]') || scope;
    const controls = Array.from(productScope.querySelectorAll('input[type="text"], input:not([type]), textarea'))
      .filter((control) => !root.contains(control) && control.offsetParent !== null)
      .filter((control) => !/^https?:\/\//i.test(String(control.value || '').trim()));

    function scoreControl(control) {
      const own = normalizeText([
        control.name, control.id, control.getAttribute('aria-label'), control.getAttribute('placeholder'),
        control.getAttribute('title'), control.getAttribute('data-label'), control.getAttribute('data-name')
      ].filter(Boolean).join(' '));
      const labelText = normalizeText(control.labels ? Array.from(control.labels).map((label) => label.textContent || '').join(' ') : '');
      const fieldWrap = control.closest('.gpo-element, .globo-form-control, .product-form__input, .field, [class*="gpo-"], [class*="globo"]');
      const nearby = normalizeText((fieldWrap?.textContent || control.parentElement?.textContent || '').slice(0, 450));
      const all = `${own} ${labelText} ${nearby}`;
      let score = 0;

      if (/amtliches kennzeichen/.test(all)) score += 500;
      if (/\bkennzeichen\b/.test(own) || /\bkenteken\b/.test(own)) score += 300;
      if (/\bkennzeichen\b/.test(labelText) || /\bkenteken\b/.test(labelText)) score += 280;
      if (/licen[cs]e plate|registration plate|number plate/.test(`${own} ${labelText}`)) score += 260;
      if (/\bkennzeichen\b|\bkenteken\b|licen[cs]e plate|registration plate|number plate/.test(nearby)) score += 120;

      if (/schriftart|wunschschrift|font|lettertype|police|czcionka|skr.f|datenschutz|privacy|url|http|email|search/.test(all)) score -= 450;
      if (control.type === 'search' || control.type === 'email' || control.type === 'url') score -= 500;
      return score;
    }

    let best = null;
    let bestScore = -9999;
    controls.forEach((control) => {
      const score = scoreControl(control);
      if (score > bestScore) { best = control; bestScore = score; }
    });
    return bestScore >= 180 ? best : null;
  }

  function findPreviewHost(scope) {
    const candidates = [
      scope.querySelector('.product__media-item.is-active .product-media-container'),
      scope.querySelector('.product__media-item:not(.is-hidden) .product-media-container'),
      scope.querySelector('.product-media-container'),
      document.querySelector('.product__media-item.is-active .product-media-container'),
      document.querySelector('.product__media-item:not(.is-hidden) .product-media-container'),
      document.querySelector('.product-media-container')
    ];
    return candidates.find(Boolean) || null;
  }

  function cameFromBlueEligibleAssistant() {
    try { return new URL(window.location.href).searchParams.get('gb_blue_recommended') === '1'; }
    catch (error) { return false; }
  }

  function markBlueEligibleProductForms(scope) {
    if (!cameFromBlueEligibleAssistant()) return;
    Array.from(scope.querySelectorAll('form[action*="/cart/add"]')).forEach((form) => {
      let input = form.querySelector('input[name="properties[_gb_blue_eligible]"]');
      if (!input) {
        input = document.createElement('input'); input.type = 'hidden';
        input.name = 'properties[_gb_blue_eligible]'; form.appendChild(input);
      }
      input.value = '1';
    });
  }

  function parseFontMap(root) {
    const node = root.querySelector('[data-gb-font-preview-map]');
    if (!node) return {};
    try { return JSON.parse(node.textContent || '{}'); } catch (e) { return {}; }
  }

  function canonicalFontName(raw) {
    const value = normalizeText(raw);
    if (!value) return '';
    for (const name of FONT_NAMES) {
      const norm = normalizeText(name);
      if (value === norm || value.includes(norm)) return name;
    }
    if (/uk\s*plate/.test(value)) return 'UK-Plate';
    if (/permanent\s*marker/.test(value)) return 'Permanent Marker';
    return '';
  }

  function isOwnFontText(raw) {
    const v = normalizeText(raw);
    return /andere\s+schrift|andere\s+schriftart|eigene\s+schrift|eigene\s+schriftart|eigene\s+wahl|beliebige\s+schrift|wunsch\s*schrift|wunsch\s*schriftart|schriftart\s+selbst|own\s+font|own\s+typeface|custom\s+font|custom\s+typeface|other\s+font|other\s+typeface|ander\s+lettertype|eigen\s+lettertype|eigen\s+keuze/.test(v);
  }

  function elementDescriptor(el) {
    if (!el) return '';
    const img = el.querySelector?.('img');
    return [
      el.getAttribute?.('data-value'), el.getAttribute?.('data-label'), el.getAttribute?.('aria-label'),
      el.getAttribute?.('title'), el.getAttribute?.('value'), img?.alt, img?.title, el.textContent
    ].filter(Boolean).join(' ');
  }

  function initCustomFontSelection(scope, root, frame, textNode, locale, fontMap) {
    let img = frame.querySelector('[data-gb-font-preview-image]');
    if (!img) {
      img = document.createElement('img');
      img.className = 'gb-plate-preview__font-image';
      img.setAttribute('data-gb-font-preview-image', '');
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      frame.appendChild(img);
    }

    let selected = '';
    let hover = '';

    function showPlaceholder() {
      img.removeAttribute('src');
      img.style.display = 'none';
      textNode.style.display = 'block';
      textNode.textContent = ownFontPlaceholder(locale);
    }

    function showFont(name) {
      if (name && fontMap[name]) {
        img.src = fontMap[name];
        img.style.display = 'block';
        textNode.style.display = 'none';
      } else {
        showPlaceholder();
      }
    }

    function renderCurrent() {
      const name = hover || selected;
      if (name === '__own__' || !name) showPlaceholder();
      else showFont(name);
    }

    function fontBySwatchIndex(target) {
      const imgTarget = target.closest?.('img');
      if (!imgTarget) return '';
      const swatchImgs = Array.from(scope.querySelectorAll('img')).filter((imgEl) => {
        const src = String(imgEl.currentSrc || imgEl.src || '');
        return /image-swatches|swatch-/i.test(src) && imgEl.offsetParent !== null;
      });
      const index = swatchImgs.indexOf(imgTarget);
      return index >= 0 && index < FONT_NAMES.length ? FONT_NAMES[index] : '';
    }

    function radioChoiceByIndex(target) {
      if (!target || !target.closest) return null;
      let radio = target.matches?.('input[type="radio"]') ? target : null;
      if (!radio) radio = target.closest('label')?.querySelector?.('input[type="radio"]') || null;
      if (!radio) radio = target.closest('[role="radio"], .gpo-swatch, .gpo-swatches-item, .gpo-image-swatch')?.querySelector?.('input[type="radio"]') || null;
      if (!radio || !radio.name) return null;

      const group = Array.from(scope.querySelectorAll('input[type="radio"]')).filter((item) => item.name === radio.name);
      /* Die Schriftart-Auswahl besteht in diesem Produkt aus 17 Optionen:
         1–16 feste Schriften, 17 = freie Wunschschrift. Diese Index-Erkennung
         ist absichtlich unabhängig von Globos wechselnden data-/Text-Werten. */
      if (group.length >= 17) {
        const index = group.indexOf(radio);
        if (index === 16) return { name: '__own__', node: radio.closest('label, [data-value], [role="radio"], .gpo-swatch, .gpo-swatches-item, .gpo-image-swatch') || radio };
        if (index >= 0 && index < FONT_NAMES.length) return { name: FONT_NAMES[index], node: radio.closest('label, [data-value], [role="radio"], .gpo-swatch, .gpo-swatches-item, .gpo-image-swatch') || radio };
      }
      return null;
    }

    function inspectChoice(target) {
      if (!target || !target.closest) return null;

      const indexed = radioChoiceByIndex(target);
      if (indexed) return indexed;

      const narrow = target.closest('[data-value], [data-label], input, label, [role="radio"], button, .gpo-swatch, .gpo-swatches-item, .gpo-image-swatch');
      if (narrow) {
        const desc = elementDescriptor(narrow);
        if (isOwnFontText(desc)) return { name: '__own__', node: narrow };
        const font = canonicalFontName(desc);
        if (font) return { name: font, node: narrow };
      }
      const byIndex = fontBySwatchIndex(target);
      if (byIndex) return { name: byIndex, node: target.closest('label, [data-value], [role="radio"], .gpo-swatch') || target };
      return null;
    }


    /* Freie Wunschschrift: Globo verwendet dafür ein separates Texteingabefeld.
       Sobald dieses Feld fokussiert/angeklickt oder beschrieben wird, soll die
       neutrale Vorschau Vorrang vor einer zuvor gewählten festen Schrift haben. */
    const plateInputForCustom = findPlateInput(scope, root);

    function isOwnFontInput(target) {
      if (!target || !target.matches) return false;
      if (!target.matches('input:not([type]), input[type="text"], input[type="search"], textarea')) return false;
      if (target === plateInputForCustom) return false;

      const wrap = target.closest('.gpo-element, .globo-form-control, .product-form__input, .field, [class*="gpo-"], [class*="globo"]');
      const desc = elementDescriptor(wrap || target);
      return /andere\s+schrift|eigene\s+schrift|eigene\s+wahl|beliebige\s+schrift|wunsch\s*schrift|wunsch\s*schriftart|schriftart\s+selbst|own\s+font|custom\s+font|other\s+font|lettertype|police|czcionka|skrifttype/i.test(desc);
    }

    function activateOwnFont() {
      selected = '__own__';
      hover = '';
      renderCurrent();
    }

    function readSelectedFromGlobo() {
      const checked = Array.from(scope.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked, option:checked, [aria-checked="true"]'));
      for (const node of checked) {
        const choice = inspectChoice(node);
        if (choice) return choice.name;
        const font = canonicalFontName(elementDescriptor(node));
        if (font) return font;
      }
      return '';
    }

    scope.addEventListener('mouseover', (event) => {
      const choice = inspectChoice(event.target);
      if (!choice) return;
      hover = choice.name;
      renderCurrent();
    });

    scope.addEventListener('mouseout', (event) => {
      const from = inspectChoice(event.target);
      if (!from) return;
      const related = event.relatedTarget;
      if (related && from.node.contains?.(related)) return;
      hover = '';
      renderCurrent();
    });

    function commitChoice(target) {
      /* Klick direkt in das Feld für die freie Wunschschrift darf nicht durch die
         noch gesetzte vorherige Radio-Auswahl wieder überschrieben werden. */
      if (isOwnFontInput(target)) {
        activateOwnFont();
        return;
      }

      const ownWrap = target?.closest?.('[data-value], [data-label], label, [role="radio"], button, .gpo-swatch, .gpo-swatches-item, .gpo-image-swatch, .gpo-element, .globo-form-control');
      if (ownWrap && isOwnFontText(elementDescriptor(ownWrap))) {
        activateOwnFont();
        return;
      }

      const choice = inspectChoice(target);
      if (choice) {
        selected = choice.name;
        hover = '';
        renderCurrent();
      }

      /* Globo setzt checked/aria-checked teilweise erst nach unserem Click-Handler.
         Darum lesen wir die echte Auswahl kurz danach nochmals aus. Besonders
         wichtig ist das für Option 17 = freie Wunschschrift. */
      window.setTimeout(() => {
        const actual = readSelectedFromGlobo();
        if (actual) {
          selected = actual;
          hover = '';
          renderCurrent();
        } else if (!choice) {
          const desc = elementDescriptor(target.closest?.('label, [data-value], [data-label], [role="radio"], button, .gpo-swatch, .gpo-swatches-item, .gpo-image-swatch'));
          if (isOwnFontText(desc)) {
            selected = '__own__';
            hover = '';
            renderCurrent();
          }
        }
      }, 140);
    }

    scope.addEventListener('pointerdown', (event) => {
      if (isOwnFontInput(event.target)) activateOwnFont();
    });
    scope.addEventListener('focusin', (event) => {
      if (isOwnFontInput(event.target)) activateOwnFont();
    });
    scope.addEventListener('input', (event) => {
      if (isOwnFontInput(event.target)) activateOwnFont();
    });
    scope.addEventListener('click', (event) => commitChoice(event.target));
    scope.addEventListener('change', (event) => commitChoice(event.target));

    // Start bewusst neutral. Eine bereits vom Browser/Formular gesetzte Auswahl
    // wird erst nach einer echten Änderung übernommen, damit nicht immer die
    // erste Globo-Kachel (Bauhaus) als Startbild erscheint.
    selected = '';
    renderCurrent();
  }

  function init(root) {
    const scope = root.closest('.shopify-section') || document;
    markBlueEligibleProductForms(scope);
    if (root.dataset.gbPlatePreviewBound === '1') return true;

    const previewType = root.dataset.gbPreviewType || 'standard';
    const plateInput = findPlateInput(scope, root);
    const host = findPreviewHost(scope);
    if (!host) return false;
    if (previewType !== 'custom-font' && !plateInput) return false;

    host.classList.add('gb-plate-preview__host');
    let frame = host.querySelector('[data-gb-plate-preview-frame]');
    let textNode = host.querySelector('[data-gb-plate-preview-text]');

    if (!frame) {
      frame = document.createElement('div');
      frame.className = 'gb-plate-preview__frame is-visible is-placeholder';
      frame.setAttribute('data-gb-plate-preview-frame', '');
      frame.setAttribute('aria-hidden', 'true');
      textNode = document.createElement('span');
      textNode.className = 'gb-plate-preview__text';
      textNode.setAttribute('data-gb-plate-preview-text', '');
      frame.appendChild(textNode); host.appendChild(frame);
    }

    frame.classList.toggle('is-label', previewType === 'label');
    frame.classList.toggle('is-euro', previewType === 'euro');
    frame.classList.toggle('is-custom-font', previewType === 'custom-font');

    const locale = (root.dataset.locale || document.documentElement.lang || 'de').toLowerCase().slice(0, 2);

    if (previewType === 'custom-font') {
      initCustomFontSelection(scope, root, frame, textNode, locale, parseFontMap(root));
      root.dataset.gbPlatePreviewBound = '1';
      return true;
    }

    function render(value) {
      const previewValue = previewPlateValue(value);
      const hasValue = Boolean(previewValue);
      textNode.textContent = hasValue ? previewValue : placeholder(locale);
      frame.classList.add('is-visible');
      frame.classList.toggle('is-placeholder', !hasValue);
      frame.classList.remove('is-medium', 'is-small');
      if (hasValue && previewValue.length >= 10) frame.classList.add('is-medium');
      if (hasValue && previewValue.length >= 12) frame.classList.add('is-small');
    }

    plateInput.addEventListener('input', function () {
      const cleaned = sanitizeDisplayPlate(plateInput.value);
      if (cleaned !== plateInput.value) plateInput.value = cleaned;
      render(cleaned);
    });

    render(plateInput.value);
    root.dataset.gbPlatePreviewBound = '1';
    return true;
  }

  function boot() {
    document.querySelectorAll('[data-gb-plate-preview]').forEach((root) => {
      if (init(root)) return;
      let tries = 0;
      const interval = window.setInterval(() => {
        tries += 1;
        if (init(root) || tries > 40) window.clearInterval(interval);
      }, 300);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  const observer = new MutationObserver(() => boot());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
